/* Ott-common */
import { createGAService } from '@dtvgo/google-analytics-service';

/* Utils */
import { addAccessTokenDataSubscriber, getUserAccount } from '../utils/accessTokenData';
import { APP_VERSION, GA_TRACKING_ID_ERROR, GA_TRACKING_ID_EVENTS } from '../utils/env';
import { REPORT_GA } from '../utils/constants';
import { getDeviceId } from '../utils/deviceIdUtils';
import platform from '../utils/platform';

const deviceId = getDeviceId();
export const config = {
  clientId: deviceId,
  applicationId: platform.getAppId,
  applicationVersion: APP_VERSION,
  applicationName: platform.appName,
  deviceId,
  osName: platform.osName,
};

const commonCustomDimensions = [
  'userId',
  'userType',
  'deviceId',
  'osName',
  'osVersion',
  'firmwareVersion',
  'modelName',
  'sourceProvider',
  'playSource',
];

export const gaService = createGAService(GA_TRACKING_ID_EVENTS, {
  ...config,
  customDimensions: commonCustomDimensions,
});

export const gaServiceError = createGAService(GA_TRACKING_ID_ERROR, {
  ...config,
  customDimensions: [
    ...commonCustomDimensions,
    'manifestUrl',
    'errorMessage',
    'errorDetail',
  ],
});

async function updateGAUserConfig() {
  const { uid: userId, accountType: userType } = await getUserAccount() || {};
  const newConfig = { userId, userType };
  gaService.setConfig(newConfig);
  gaServiceError.setConfig(newConfig);
}

async function updateDeviceInfo() {
  const {
    sdkVersion: osVersion,
    version: firmwareVersion,
    modelName,
  } = (await platform.getDeviceInfo()) || {};
  const newConfig = {
    osVersion,
    firmwareVersion,
    modelName,
  };
  gaService.setConfig(newConfig);
  gaServiceError.setConfig(newConfig);
}

export function reportLoadDrmAgentError(error) {
  gaServiceError.sendEvent({
    action: REPORT_GA.GA_ERROR_EVENT_ACTION_DRM_AGENT,
    label: `${error.keySystemToUse} - ${error.code} - ${error.message}`,
    category: REPORT_GA.GA_ERROR_EVENT_CATEGORY,
  });
}

updateDeviceInfo();
updateGAUserConfig();
addAccessTokenDataSubscriber(updateGAUserConfig);
